import reducer from "../../redux/reducers/index";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
const initialState = {};
const middleware = [thunk];
const store = createStore(
  reducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  )
);

// const reducer = combineReducers({
//   form: reduxFormReducer, // mounted under "form",
//   theme: themeReducer,
//   sidebar: sidebarReducer,
//   rtl: rtlReducer,
// });

// const store = createStore(reducer);

export default store;
